module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAP1BMVEUAAABXV1dXV1daWlpWVlZWVlZaWlpYWFhWVlZXV1dYWFhYWFhiYmJWVlZWVlZXV1dZWVlYWFhZWVldXV1WVlZvRNLjAAAAFHRSTlMAmWYzzNYloz7shHoI9K6lczEUHk8vPHoAAACpSURBVEjH7dRLDsMgDEVRDIYG8k+9/7UWkZYOMFaiSlFS5Yx9B548daDOCTomMCQwbOChwlcCVBV4B2cMnE4C+UeFp6ATlwJNm+l3YCEarWCEyOYA1CZw1eBpom5HABSZHUGLkTvV038ftMBqqwESC4Ug6EIQA8OOw++Bx1VPUxlM1OPK5+ArlEEoVmMxH5aaMmjI5oNFZfIP2RWCAQqDGHCEYG5YszrUC+zsGFlRKYfkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/zxyl/dy_icon.png
// module id = 6nwV
// module chunks = 2